import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { Table } from 'primeng/table';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { CultivosAforosViewModel, TwCorteCultivoCamViewModel } from '../../unidad-inspeccion-datosbasicos.types';

@Component({
    selector: 'app-inspeccion-ui-aforo-corte-list',
    templateUrl: './inspeccion-ui-aforo-corte-list.component.html',
    styleUrls: ['./inspeccion-ui-aforo-corte-list.component.scss'],
})
export class InspeccionUiAforoCorteListComponent extends ComponentBase implements OnInit {
    @Input() hasDeletingAccess = false;
    @Input() hasViewAccess = false;
    @Input() actionNotAllowed = false;
    @Input() readonly = false;
    @Input() cultivosAforosCortes: CultivosAforosViewModel[] = [];
    @Input() title: { plural: string; singular: string };
    @Output() delete = new EventEmitter<TwCorteCultivoCamViewModel>();
    @Output() view = new EventEmitter<TwCorteCultivoCamViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    constructor(
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.initCols();
    }

    private initCols(): void {
        const cultivoAforoCorte = proxiedPropertiesOf<CultivosAforosViewModel>();

        this.cols = [
            { field: 'ExpandLink', header: '' },
            { field: cultivoAforoCorte.CodigoSigPacRecinto, header: 'Código SigPac' },
            { field: cultivoAforoCorte.IdentificadorCultivo, header: 'Identificador Cultivo' },
            { field: cultivoAforoCorte.Variedad, header: 'Variedad' },
            { field: cultivoAforoCorte.Superficie, header: 'Superficie (ha)' },
            { field: cultivoAforoCorte.AforoDescripcion, header: 'Aforo' },
            { field: cultivoAforoCorte.KgsProduccionEstimada, header: 'Prod. Estimada (Kg)' },
            { field: cultivoAforoCorte.KgsProduccionReal, header: 'Prod. Aforada (Kg)' },
            { field: cultivoAforoCorte.KgsProduccionRestante, header: 'Cant. Restante (Kg)' },
        ];
    }

    onDelete(rowData: CultivosAforosViewModel, corteCultivo: TwCorteCultivoCamViewModel): void {
        this.delete.emit(corteCultivo);
    }

    onView(rowData: CultivosAforosViewModel, corteCultivo: TwCorteCultivoCamViewModel): void {
        this.view.emit(corteCultivo);
    }

    canBeDeleted(corteCultivo: TwCorteCultivoCamViewModel): boolean {
        return corteCultivo?.FechaBorrado === null;
    }

    esCorteCaducado(FechaCaducidad: string): boolean {
        if (!FechaCaducidad) {
            return false;
        }
        const ahora = new Date();
        const FechaBorrado = new Date(FechaCaducidad);
        return FechaBorrado < ahora;
    }
}
